"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import { Rowselectheader } from "./Rowselectheader";
import { SelectHeaderItem } from "./SelectHeaderItem";
import * as _utils from "./utils";
import _styles from "./ImportSelectheader.module.css";

// const _interactionsData = JSON.parse(
//   '{"events":{"e-29":{"id":"e-29","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-30"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fe72244b-d501-7636-f67d-84ac756e6330","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fe72244b-d501-7636-f67d-84ac756e6330","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701788300569},"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"fb8393e1-a5a8-78cf-fb44-707439dc9f81","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"fb8393e1-a5a8-78cf-fb44-707439dc9f81","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701788353129},"e-35":{"id":"e-35","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-13","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-36"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"25c1c552-09f8-ae8c-3646-6b2117769b4d","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"25c1c552-09f8-ae8c-3646-6b2117769b4d","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701788415357},"e-37":{"id":"e-37","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-14","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-38"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"4844bdd3-f723-eba9-d9f1-a91bd97b4e7a","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"4844bdd3-f723-eba9-d9f1-a91bd97b4e7a","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701788461083},"e-39":{"id":"e-39","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-40"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"43b1d49e-a67a-3132-4a90-e859f7107a36","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"43b1d49e-a67a-3132-4a90-e859f7107a36","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701788524366},"e-41":{"id":"e-41","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-42"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"4844bdd3-f723-eba9-d9f1-a91bd97b4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"4844bdd3-f723-eba9-d9f1-a91bd97b4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1701788568275}},"actionLists":{"a-11":{"id":"a-11","title":"import popup [close]","actionItemGroups":[{"actionItems":[{"id":"a-11-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".import-popup","selectorGuids":["41744e62-6efc-b5ef-8c38-cc2a49bc8b35"]},"value":"none"}},{"id":"a-11-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".upload","selectorGuids":["309e488d-196f-42d2-4338-7f7ce2b2fdc0"]},"value":"flex"}},{"id":"a-11-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".select-header","selectorGuids":["55231c23-efd3-5947-cd01-a42b5df7f6eb"]},"value":"none"}},{"id":"a-11-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".match-columns","selectorGuids":["5687aa0a-c63b-33de-4582-0bd0da615aee"]},"value":"none"}},{"id":"a-11-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".validate-data","selectorGuids":["9f9e528e-1c3c-7e9b-e856-e04af4fdf4e7"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701788303042},"a-13":{"id":"a-13","title":"match RETURN TO select","actionItemGroups":[{"actionItems":[{"id":"a-13-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".match-columns","selectorGuids":["5687aa0a-c63b-33de-4582-0bd0da615aee"]},"value":"none"}},{"id":"a-13-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".select-header","selectorGuids":["55231c23-efd3-5947-cd01-a42b5df7f6eb"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701788418315},"a-14":{"id":"a-14","title":"select RETURN TO Upload","actionItemGroups":[{"actionItems":[{"id":"a-14-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".upload","selectorGuids":["309e488d-196f-42d2-4338-7f7ce2b2fdc0"]},"value":"flex"}},{"id":"a-14-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".select-header","selectorGuids":["55231c23-efd3-5947-cd01-a42b5df7f6eb"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701788466944},"a-15":{"id":"a-15","title":"upload GO TO select","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".upload","selectorGuids":["309e488d-196f-42d2-4338-7f7ce2b2fdc0"]},"value":"none"}},{"id":"a-15-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".select-header","selectorGuids":["55231c23-efd3-5947-cd01-a42b5df7f6eb"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701788528385},"a-16":{"id":"a-16","title":"select GO TO Match","actionItemGroups":[{"actionItems":[{"id":"a-16-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".select-header","selectorGuids":["55231c23-efd3-5947-cd01-a42b5df7f6eb"]},"value":"none"}},{"id":"a-16-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".match-columns","selectorGuids":["5687aa0a-c63b-33de-4582-0bd0da615aee"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701788570919}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
// );

export function ImportSelectheader({ as: _Component = _Builtin.Block, back = () => { }, step = 1, handleSelectedHeader = () => { }, rowHeader = {}, handleCheckboxChange = () => { }, selectedRows = {} }) {
  // _interactions.useInteractions(_interactionsData, _styles);

  const [headers, setHeaders] = React.useState([]);
  const [allChecked, setAllChecked] = React.useState(false);
  React.useEffect(() => {
    if (Object.keys(rowHeader).length > 0 && rowHeader.header) {
      setHeaders(rowHeader.header);
    }
  }, [rowHeader]);

  if (step != 2) return null;


  const handleSelectAll = (isChecked) => {
    setAllChecked(isChecked);
    console.log("handleSelectAll", isChecked);

    const updatedHeaders = Object.keys(headers).reduce((acc, key) => {
      acc[key] = {
        ...headers[key],
        isChecked: isChecked,
      };
      return acc;
    }, {});

    setHeaders(updatedHeaders);
  };

  return (
    <_Component className={_utils.cx(_styles, "select-header")} tag="div" style={{ display: step == 2 ? "flex" : "none" }}>
      <_Builtin.Block
        className={_utils.cx(_styles, "progresscontainer")}
        tag="div"
      >
        <_Builtin.Block className={_utils.cx(_styles, "progress")} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, "progress_num", "bg-green")}
            tag="div"
          >
            <_Builtin.Block tag="div">{"1"}</_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block tag="div">{"Upload file"}</_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "progressline", "bg-green")}
          tag="div"
        />
        <_Builtin.Block className={_utils.cx(_styles, "progress")} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, "progress_num", "bg-green")}
            tag="div"
          >
            <_Builtin.Block tag="div">{"2"}</_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block tag="div">{"Select header row"}</_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "progressline")}
          tag="div"
        />
        <_Builtin.Block className={_utils.cx(_styles, "progress")} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, "progress_num")}
            tag="div"
          >
            <_Builtin.Block tag="div">{"3"}</_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block tag="div">{"Match Columns"}</_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "progressline")}
          tag="div"
        />
        <_Builtin.Block className={_utils.cx(_styles, "progress")} tag="div">
          <_Builtin.Block
            className={_utils.cx(_styles, "progress_num")}
            tag="div"
          >
            <_Builtin.Block tag="div">{"4"}</_Builtin.Block>
          </_Builtin.Block>
          <_Builtin.Block tag="div">{"Validate Data"}</_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, "popup_content")} tag="div">
        <_Builtin.Block
          className={_utils.cx(_styles, "popupcontent-headerdiv")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "iconbtn-return")}
            onClick={() => back()}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "image-100")}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src="images/66968578d5889c78730e319a_icon_return.svg"
            />
          </_Builtin.Block>
          <_Builtin.Heading
            className={_utils.cx(_styles, "popup_contentheader")}
            tag="h3"
          >
            {"Select Header Row"}
          </_Builtin.Heading>
        </_Builtin.Block>
        <_Builtin.Block className={_utils.cx(_styles, "popup_table")} tag="div">
          <_Builtin.FormWrapper className={_utils.cx(_styles, "form-block")}>
            <_Builtin.FormForm
              name="email-form"
              // data-name="Email Form"
              method="get"
            // id="email-form"
            >
              <_Builtin.Block
                className={_utils.cx(_styles, "tablecontainer")}
                tag="div"
              >
                <Rowselectheader
                  key="selectAll"
                  name="Select All"
                  isChecked={allChecked}
                  onCheckboxChange={handleSelectAll}
                />
                {headers && Object.entries(headers).map(([key, value]) => {
                  return (
                    <Rowselectheader
                      key={key}
                      name={key}
                      isChecked={headers[key].isChecked ? headers[key].isChecked : false}
                      onCheckboxChange={(isChecked) => {
                        const updatedHeaders = Object.keys(headers).reduce((acc, k) => {
                          if (k === key) {
                            acc[k] = {
                              ...value,
                              isChecked,
                            };
                          } else {
                            acc[k] = headers[k];
                          }
                          return acc;
                        }, {});
                        setHeaders(updatedHeaders);

                        const allChecked = Object.keys(updatedHeaders).every((k) => updatedHeaders[k].isChecked);
                        setAllChecked(allChecked);
                      }}
                    />);
                })}
                <_Builtin.Block
                  className={_utils.cx(_styles, "tablerow_container")}
                  tag="div"
                >
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.FormForm>
            <_Builtin.FormSuccessMessage>
              <_Builtin.Block tag="div">
                {"Thank you! Your submission has been received!"}
              </_Builtin.Block>
            </_Builtin.FormSuccessMessage>
            <_Builtin.FormErrorMessage>
              <_Builtin.Block tag="div">
                {"Oops! Something went wrong while submitting the form."}
              </_Builtin.Block>
            </_Builtin.FormErrorMessage>
          </_Builtin.FormWrapper>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "popup_btncontainer")}
          tag="div"
        >
          <_Builtin.Link
            className={_utils.cx(_styles, "btn", "_w-100")}
            onClick={() => handleSelectedHeader(headers)}
            button={false}
            block="inline"
            options={{
              href: "#",
            }}
          >
            <_Builtin.Block tag="div">{"Next"}</_Builtin.Block>
          </_Builtin.Link>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
